import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import sv from './locales/sv/translation.json';
import da from './locales/da/translation.json';
import de from './locales/de/translation.json';
import es from './locales/es/translation.json';
import fr from './locales/fr/translation.json';
import it from './locales/it/translation.json';
import fi from './locales/fi/translation.json';
import no from './locales/no/translation.json';
import tr from './locales/tr/translation.json';
import pl from './locales/pl/translation.json';

const urlParams = new URLSearchParams(window.location.search);
const urlLang = urlParams.get('lang');
const savedLang = urlLang || localStorage.getItem('language') || 'en';

i18n
  .use(initReactI18next)
  .init({
    lng: savedLang,
    fallbackLng: 'en',
    supportedLngs: ['en', 'sv', 'da', 'de', 'es', 'fr', 'it', 'fi', 'no', 'tr', 'pl'],
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: en },
      sv: { translation: sv },
      da: { translation: da },
      de: { translation: de },
      es: { translation: es },
      fr: { translation: fr },
      it: { translation: it },
      fi: { translation: fi },
      no: { translation: no },
      tr: { translation: tr },
      pl: { translation: pl },
    },
  });

export default i18n;